import { useAuthWithSSRService } from "@storytell/auth-ssr-implementation";
import { useDeviceService } from "@storytell/device";
import { getEnvironmentConfig } from "@storytell/environment";
import { useLocaleService } from "@storytell/locale";
import { Client as ClientLogger, type Logger, Server as ServerLogger } from "@storytell/logger";
import { getRequestEvent, isServer } from "solid-js/web";
import type { Wire } from "./definition";

export const newWire = (): Wire => {
  const logger = initLogger();
  const locale = useLocaleService();
  const device = useDeviceService({
    logger,
    variant: "app",
  });
  const event = getRequestEvent();

  const userAgent = () => {
    if (isServer) {
      return event?.request?.headers.get("user-agent") || "";
    }
    return navigator.userAgent;
  };

  const auth = useAuthWithSSRService({
    logger,
    deviceId: device.getDeviceId,
    locale: locale.getLocale,
    userAgent,
  });

  return {
    auth,
    device,
    logger,
    locale,
    environment: getEnvironmentConfig(),
  };
};

export const validateWire = (wire: Wire) => {
  const newErrorMessage = (dependency: string): string => {
    return `Dependency validation for the wire failed for '${dependency}'.`;
  };
  if (!wire.logger) {
    throw new Error(newErrorMessage("logger"));
  }
  if (!wire.auth) {
    throw new Error(newErrorMessage("auth"));
  }
  if (!wire.environment || Object.keys(wire.environment).length === 0) {
    throw new Error(newErrorMessage("environment"));
  }
  return;
};

// initLogger initializes the logger based on the environment.
const initLogger = (): Logger => (isServer ? new ServerLogger("_") : new ClientLogger("_"));
